export default "__VITE_ASSET__DCx2EaYa__"